<template>
  <div class="commit-info" ref="commitinfo">
    <section class="guide-info">
      <div class="main">{{ title }}</div>
      <div class="detail">{{ content }}</div>
      <!-- <div class="detail">{{ res }}</div> -->
    </section>

    <section class="basic-info">
      <div class="item">
        <input
          class="user-name"
          type="text"
          v-model="name"
          placeholder="请输入真实姓名"
          maxlength="15"
        />
      </div>
      <div class="item">
        <input
          class="user-card-id"
          type="text"
          v-model="idcard"
          placeholder="请输入证件号码"
          maxlength="18"
        />
      </div>
    </section>
    <div class="agreement-list">
      <z-checkbox
        v-if="isZZ"
        v-model="agreementChecked.zz"
        :checked-color="isHeroClub ? '#111111' : ''"
      >
        我已阅读并同意
        <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
      </z-checkbox>

      <z-checkbox
        v-if="isZzqcidentity"
        v-model="agreementChecked.zzqc"
        :checked-color="isHeroClub ? '#111111' : ''"
      >
        我已阅读并同意
        <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
      </z-checkbox>

      <z-checkbox
        v-model="agreementChecked.privacy"
        :checked-color="isHeroClub ? '#111111' : ''"
      >
        我已阅读并同意
        <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
      </z-checkbox>

      <z-checkbox
        v-if="isZLJ"
        v-model="agreementChecked.zlj"
        :checked-color="isHeroClub ? '#111111' : ''"
      >
        我已阅读并同意
        <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
      </z-checkbox>

      <z-checkbox
        v-if="isHeroClub"
        v-model="agreementChecked.heroclub"
        :checked-color="isHeroClub ? '#111111' : ''"
      >
        我已阅读并同意
        <span :style="{ color: '#42A0FF' }" @click.stop="heroclubagreement">《侠客汇身份识别服务协议》</span>
      </z-checkbox>
    </div>
    <z-button-group>
      <z-button
        type="primary"
        btn-class="bottombtn"
        :disabled="!canSubmit"
        @click="submit"
        >开始验证</z-button
      >
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { getMaskData } from '@zz-common/zz-utils'
import { Button, ButtonGroup, Checkbox } from '@zz-common/zz-ui'
import { toast } from '../../native'
import { queryParams, skipClose, isHeroClubByUa } from '../../lib/utils'

import { getsdkuserauthtext } from '../../api/resourceApi';
// import DAL from '../../dal'

// import BottomButton from './BottomButton/BottomButton'

const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    return {
      sourcecode: query.sourcecode || this.$route.query.sourcecode,
      authtype: query.authtype || this.$route.query.authtype,
      // 提交文案
      title: '',
      content: '',
      // 二要素
      name: '',
      idcard: '',
      res: '',
      //请求状态
      token: '',
      btnText: '开始验证',
      submiting: false,
      // 协议选中状态
      agreementChecked: {
        zz: false, // 转转实人认证服务协议
        zzqc: false, // zzqcidentity实人认证服务协议
        privacy: false, // 个人信息处理授权书（必选）
        zlj: false, // 找靓机身份识别服务协议
        heroclub: false // 侠客汇身份识别服务协议
      },
      // 环境判断
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isZzqcidentity: native.in('zzqcidentity'),
      isHeroClub: isHeroClubByUa()
    }
  },
  computed: {
    /**
     * 判断是否可以提交
     * 需要满足：
     * 1. 姓名和身份证号格式正确
     * 2. 所有显示的协议都已勾选
     * 3. 未在提交中
     */
    canSubmit() {
      // 基础信息校验
      const hasValidInfo = this.isUserNameValid() && this.isIDCardValid()

      // 协议勾选状态校验 - 所有应该显示的协议都必须勾选
      // 个人信息处理授权书是必选的
      const privacyChecked = this.agreementChecked.privacy
      // 转转实人认证服务协议（如果显示）
      const zzChecked = !this.isZZ || this.agreementChecked.zz
      // zzqcidentity实人认证服务协议（如果显示）
      const zzqcChecked = !this.isZzqcidentity || this.agreementChecked.zzqc
      // 找靓机身份识别服务协议（如果显示）
      const zljChecked = !this.isZLJ || this.agreementChecked.zlj
      // 侠客汇身份识别服务协议（如果显示）
      const heroclubChecked = !this.isHeroClub || this.agreementChecked.heroclub

      const allAgreementsChecked = privacyChecked && zzChecked && zzqcChecked && zljChecked && heroclubChecked

      return hasValidInfo && allAgreementsChecked && !this.submiting
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zCheckbox: Checkbox
  },
  mounted() {
    lego.send({
      pagetype: 'ZZUP_IDCARDAUTH_COMMITINFO',
      actiontype: 'ZLJ_PAGE_SHOW'
    })
    native.setTitle({
      title: '实名认证'
    })
    if (this.authtype === 'reverify') {
      this.name = localStorage.getItem('userName') || ''
      this.idcard = localStorage.getItem('userCardNo') || ''
    }
    // 身份号认证获取页面文案信息
    getsdkuserauthtext({
      sourcecode: this.sourcecode
    })
      .then((res) => {
        this.title = res.title
        this.content = res.content
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err,
          style: '2'
        })
      })
    native.wrap('setKeyboardFrameChangeCallback')((res) => {
      if (!res.kbState) return
      if (res.kbState == '0') {
        console.log(this.$refs.commitinfo.scrollTop)
        if (this.$refs.commitinfo) {
          this.$refs.commitinfo.scrollTop = 0
        }
      }
    })
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    isUserNameValid() {
      const regName = /^[\u2e80-\u9fff]+(·[\u2e80-\u9fff]+)*$/
      return regName.test(this.name)
    },
    isIDCardValid() {
      const regIdNo = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return regIdNo.test(this.idcard)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      const targetUrl = this.isHeroClub ? 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6698f702c68048006a695502/index.html?magicplatform=zz&needNewWebview=1' : 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1'
      native.skipToUrl({
        targetUrl,
        needClose: '0'
      })
    },
    heroclubagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6698f7760bf2ed006a040567/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljUpload() {
      native.wrap('getSystemCamera')({
        success: (res) => {
          if (!(res)) return;
          console.log('res', res);
          const { statusCode, photoString } = res;
          const code = +statusCode;
          if (code === 1) {
            console.log('photoString', photoString);
            // this.$emit('uploaded', photoString, Date.now())
          }
        }
      })
    },
    submit() {
      if (!this.isUserNameValid()) {
        return toast({
          msg: '姓名错误，请填写中文',
          style: '2'
        })
      }
      if (!this.isIDCardValid()) {
        return toast({
          msg: '身份证号错误，请填写 18 位数字和字母',
          style: '2'
        })
      }
      //需要扫脸
      console.log('需要扫脸')
      const params = {
        source_code: this.sourcecode,
        card_name: this.name,
        card_no: this.idcard
      };
      console.log('params', params);
      //隐私上报
      const maskData = getMaskData({
        A01_08: this.name,
        C01_03: this.idcard
      })
      lego.send({
        pagetype: 'privacy',
        actiontype: 'information',
        backup: {
          value: JSON.stringify(maskData || {})
        }
      })
      native.wrap('faceRecognitionOcr')({
        source_code: this.sourcecode,
        card_name: this.name,
        card_no: this.idcard
      },
      (res) => {
        console.log('扫脸返回数据')
        console.log(res)
        this.res = JSON.stringify(res);
        const { statusCode, statusText, data: { agreementNo } = {} } = res;
        console.log('statusCode', statusCode);
        console.log('agreementNo', agreementNo);
        if (statusCode && agreementNo) {
          const targetUrl = `https://feentry.zhuanzhuan.com/auth_face?clientid=ZLJRealAuthResult&sourcecode=${this.sourcecode}&code=${statusCode}&agreementNo=${agreementNo}`;
          // if (isIOS()) {
          //   return window.location.replace(targetUrl)
          // }
          // setTimeout(() => {
          //   native.close();
          // }, 100)
          // return native.skipToUrl({
          //   targetUrl,
          //   needClose: '1'
          // })
          skipClose(targetUrl);
        } else if (statusCode && statusText) {
          toast({
            msg: statusText,
            style: '2'
          })
        }
      }
      )
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'commit.less';
</style>
